import { Font } from '@/constants';
import { createContext } from 'react';

export const AssetsContext = createContext<ContextProps>({
	fonts: [],
	error: null,
	isLoading: false,
});

interface ContextProps {
	fonts: Array<Font>;
	error: Error | null;
	isLoading: boolean;
}
